import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { ShareValuesService } from 'src/app/services/sharedValues/share-values.service';
import { Location } from '@angular/common';
import { LoadingController, ModalController, PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { isNotEmptyArray } from 'src/app/utilities/utils';
import { ToastService } from 'src/app/services/toast.service';
import { AppConstants } from 'src/app/utilities/constant';

@Component({
  selector: 'app-add-roadmap-to-machine',
  templateUrl: './add-roadmap-to-machine.component.html',
  styleUrls: ['./add-roadmap-to-machine.component.scss'],
})
export class AddRoadmapToMachineComponent implements OnInit {
  availableRoadMap: any=[];
  isAllRoadmapSelected: boolean;
  seletedTab='rm';
  @Input() machineDetails: any;
  selectedRoadmaps: any=[];
  constructor(
    public backendService: BackendCallService,
    private router: Router,
    private route: ActivatedRoute,
    public sharedValue: ShareValuesService,
    private _location: Location,
    public popoverController: PopoverController,
    public modalController: ModalController,
    public translate: TranslateService,
    public loadingController: LoadingController,
    private toastService: ToastService
  ) {
  }

  ngOnInit() {
      //  this.availableRoadMap=this.sharedValue.dummydata
      //  this.availableRoadMap.forEach((each) => {
      //    each.isRoadmapChecked=false;
      //    each.addAnswers=false;
      //  });
  }

  ionViewWillEnter(){
    this.getMachineRoadmaps(this.machineDetails.id);
  }

  async presentLoading(msg) {
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-loading',
      message: msg,
      spinner: 'bubbles'
    });
    await loading.present();
    return loading;
  }

  async getMachineRoadmaps(availableRoadMap) {
    this.availableRoadMap = [];
    this.backendService.getMachineRoadmaps(availableRoadMap).subscribe((res: any) => {
      res.forEach((each) => {
        each.isRoadmapChecked=false;
        each.isSelected=false;

      });
      this.availableRoadMap=res;
    }, error => {
      (err) => {
      };
    });
  }

  close() {
    this.modalController.dismiss();
  }

  next(){
    if(this.seletedTab=='rm'){
      this.selectedRoadmaps=[];
      this.availableRoadMap.forEach(element => {
        if (element.isRoadmapChecked) {
          this.selectedRoadmaps.push(element);
        }
      });
      this.selectedRoadmaps = [...new Set(this.selectedRoadmaps)];
      const isAnyRoadMapSelected = this.availableRoadMap.some(_mli => _mli.isRoadmapChecked);
      if (isAnyRoadMapSelected){this.seletedTab='qs';}else{
       this.toastService.presentToast(this.translate.instant('please_select_roadmap'), 4000, AppConstants.ERROR_SNACKBAR, 'top');}
    }
  }

  previous(){
    if(this.seletedTab=='qs'){
      this.seletedTab='rm';
    }
  }


  changeRoadMapCheckboxSelection(event, roadmapData) {
    event.stopPropagation();
    const isAnyRoadMapSelected = this.availableRoadMap.some(_mli => _mli.isRoadmapChecked);
    if (!isAnyRoadMapSelected) {this.isAllRoadmapSelected = isAnyRoadMapSelected;}
    this.availableRoadMap.forEach(element => {
      if (element.id == roadmapData.id) {
        element.isRoadmapChecked != element.isRoadmapChecked;
      }
    });
  }

  changeAnswersCheckboxSelection(isSelected: boolean, roadmapData) {
    roadmapData.isSelected = isSelected;
  }

 async updateData(){
   await this.selectedRoadmaps.forEach(async (roadmap) => {
      if(!roadmap.isSelected &&roadmap.roadMapSections.length){
        await  roadmap.roadMapSections.forEach(async (roadMapSection) => {
          if(roadMapSection?.roadMapSubSection&&roadMapSection.roadMapSubSection.length){
            await  roadMapSection.roadMapSubSection.forEach(async (eachRoadMapSubSection)=>{
              if(eachRoadMapSubSection.stepMaster&&eachRoadMapSubSection.stepMaster.length){
                await eachRoadMapSubSection.stepMaster.forEach(async (step)=>{
                  if(step.answers.length){
                    step.answers=[];
                  }
                });

              }
            });
        }
        });
      }
    });
  }

 async submit(){
   await this.modalController.dismiss(this.selectedRoadmaps);
  }
}
